'use client';

import { centerToastModalAtom } from '@/atom/modal';
import { useAtom } from 'jotai';
import { useEffect, useMemo, useState } from 'react';
import CheckGradient5656 from '@/images/check_gradient_56_56.png';
import Image from 'next/image';

const RENDERING_TIME = 1000;

export default function CenterToastModal() {
  const [centerToastModal, setCenterToastModal] = useAtom(centerToastModalAtom);
  const [fadeType, setFadeType] = useState<'fade-in' | 'fade-out'>();

  const renderingTime = useMemo(
    () => centerToastModal?.renderingTime ?? RENDERING_TIME,
    [centerToastModal?.renderingTime],
  );

  useEffect(() => {
    if (fadeType === 'fade-out') return;

    const fadeoutTimeout = setTimeout(() => setFadeType('fade-out'), renderingTime);

    return () => {
      clearTimeout(fadeoutTimeout);
    };
  }, [fadeType, renderingTime]);

  useEffect(() => {
    if (fadeType === 'fade-in') return;
    const FADE_TIME = 250;

    const resetTextTimeout = setTimeout(() => {
      setCenterToastModal(undefined);
    }, renderingTime + FADE_TIME);

    return () => clearTimeout(resetTextTimeout);
  }, [fadeType, renderingTime, setCenterToastModal]);

  useEffect(() => {
    if (!centerToastModal) return;
    setFadeType('fade-in');
  }, [centerToastModal]);

  if (!centerToastModal) return null;

  return (
    <div
      className={`fixed flex flex-col items-center -translate-x-1/2 -translate-y-1/2 left-1/2 top-1/2 px-10pxr py-30pxr min-w-142pxr gap-16pxr rounded-15pxr ${fadeType} z-[9999]`}
      style={{ background: 'rgba(10,10,10,0.8)' }}
    >
      {!centerToastModal.iconHidden && (
        <span className='relative w-56pxr h-56pxr'>
          <span className='absolute -translate-x-1/2 -translate-y-1/2 bg-white rounded-full w-40pxr h-40pxr top-1/2 left-1/2'></span>
          <Image
            src={CheckGradient5656}
            alt='check-gradient'
            width={56}
            height={56}
            className='absolute top-0 left-0 z-2'
          />
        </span>
      )}
      <p className='text-center text-white whitespace-pre-line sub-heading-16-m'>{centerToastModal.text}</p>
    </div>
  );
}
